var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7503 28.3332C15.905 28.3332 20.0837 24.1545 20.0837 18.9998C20.0837 13.8452 15.905 9.6665 10.7503 9.6665C5.59567 9.6665 1.41699 13.8452 1.41699 18.9998C1.41699 24.1545 5.59567 28.3332 10.7503 28.3332Z",
    fill: "#713B12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 20.2501C24.5641 19.6392 28.0837 15.7305 28.0837 10.9998C28.0837 5.84518 23.905 1.6665 18.7503 1.6665C14.0196 1.6665 10.111 5.18606 9.50002 9.74953M20.0837 18.9998C20.0837 24.1545 15.905 28.3332 10.7503 28.3332C5.59567 28.3332 1.41699 24.1545 1.41699 18.9998C1.41699 13.8452 5.59567 9.6665 10.7503 9.6665C15.905 9.6665 20.0837 13.8452 20.0837 18.9998Z",
    stroke: "#713B12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLock);
export default __webpack_public_path__ + "static/media/coinLock.ac689c02801bcbcc5f8f903d77987d69.svg";
export { ForwardRef as ReactComponent };